<mat-spinner *ngIf="loading"></mat-spinner>

<div *ngIf="!loading" (resized)="onResized($event)">
  <iframe
    [style.width.px]="widthExp"
    height="500"
    *ngIf="getSafeResourceUrl() && !addingDiagnostic"
    [src]="getSafeResourceUrl()"
    type="application/pdf"
  ></iframe>
  <div  *ngIf="addingDiagnostic">
    <app-structured-diagnosis-panel

      [allItemSelected]="data.StructuredDiagnosisColumnItems"
      [allColumns]="data.StructuredDiagnosisColumns"
    >
    </app-structured-diagnosis-panel>
  </div>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button
      mat-button
      type="button"
      *ngIf="
        !addingDiagnosticSelected &&
        diagnositcRequired &&
        canConfirm &&
        !loading
      "
      (click)="addDiagnostic()"
    >
      Agregar diagnóstico
    </button>
    <button
      mat-button
      type="button"
      *ngIf="
        (!diagnositcRequired || hasDiagnosticSelected()) &&
        canConfirm &&
        !loading
      "
      (click)="confirmClick()"
    >
      Confirmar
    </button>
    <button
    mat-button
    type="button"
    *ngIf="!loading && data.CanControl"
    (click)="onConfirmAdminClick()"
  >
    Controlado
  </button>
  <button
  *ngIf="!loading && data.CanFix"
  mat-button
  type="button"
  cdkFocusInitial
  (click)="onFixClick()"
>
  Corregir
</button>
    <button
      *ngIf="!loading"
      mat-button
      type="button"
      cdkFocusInitial
      (click)="onNoClick()"
    >
      Salir
    </button>
  </div>
</div>
